jQuery(document).ready(function ($) {
    const usps = new Swiper('.usps__content', {
        loop: true,

        slidesPerView: 1,
        slidesPerGroup: 1,

        spaceBetween: 0,

        pagination: {
            el: '.usps__pagination',
            type: 'bullets',
            bulletClass: 'pagination__bullet',
            bulletActiveClass: 'active',
            clickable: true
        },

        autoplay: {
            delay: 8000,
        },
        speed: 500,

        //grabCursor: true,

        breakpoints: {
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,

                pagination: false,
            }
        }
    });
});